import {timeStampToDate} from "../../modules/utils";

export const getDateRun = () => {
  const date = new Date();

  return timeStampToDate(date);
}
